import { Component, inject, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslationService } from "@core/services/translation.service";
import { SessionTimeoutService } from "@core/services/session-timeout.service";
import { TranslateModule } from "@ngx-translate/core";
import { ToastNotificationComponent } from "@shared/components/atoms/toast-notification/toast-notification.component";
import { ConditionalLayoutComponent } from "@shared/components/templates/conditional-layout/conditional-layout.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [RouterOutlet, TranslateModule, ToastNotificationComponent, ConditionalLayoutComponent],
})
export class AppComponent implements OnInit {
  private readonly translationService = inject(TranslationService);
  private readonly sessionTimeoutService = inject(SessionTimeoutService);

  constructor() {
    this.translationService.initializeLanguage();
  }

  ngOnInit(): void {
    this.sessionTimeoutService.initialize();
  }
}
